import React from 'react';
import { Shield, Camera, Zap } from 'lucide-react';
import { experiencePractice } from '../data/mock';
import { trackCtaClick } from '../utils/analytics';

const iconMap = {
  'shield': Shield,
  'camera': Camera,
  'zap': Zap
};

const ExperiencePractice = () => {
  const handleContactSecurity = () => {
    const subject = "Segurança / conectividade / automação";
    const message = encodeURIComponent(`Olá! Gostaria de conversar sobre ${subject}.`);
    const whatsappUrl = `https://wa.me/5511984845464?text=${message}`;
    trackCtaClick({ cta: 'whatsapp', location: 'contact', url: whatsappUrl });
    window.open(whatsappUrl, '_blank');
  };

  return (
    <section id="experiencia-pratica" className="section-padding">
      <div className="container-custom">
        <h2 className="section-title">Experiência na prática (Segurança, IoT e Automação)</h2>
        
        <div className="experience-grid">
          {experiencePractice.map((item) => {
            const IconComponent = iconMap[item.icon] || iconMap["shield"];
            return (
              <div key={item.id} className="experience-card">
                <div className="experience-icon">
                  <IconComponent size={32} />
                </div>
                <h3 className="experience-title">{item.title}</h3>
                <p className="experience-description">{item.description}</p>
              </div>
            );
          })}
        </div>

        <div className="experience-cta">
          <button onClick={handleContactSecurity} className="btn-secondary">
            Ver como posso ajudar
          </button>
        </div>
      </div>
    </section>
  );
};

export default ExperiencePractice;
